/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ScheduledDowntimeKind = {
    _11184809: '11184809',
    RECURRING: 'RECURRING',
    ONE_OFF: 'ONE_OFF',
    unknown_default_open_api: '11184809'
} as const;
export type ScheduledDowntimeKind = typeof ScheduledDowntimeKind[keyof typeof ScheduledDowntimeKind];


export function instanceOfScheduledDowntimeKind(value: any): boolean {
    for (const key in ScheduledDowntimeKind) {
        if (Object.prototype.hasOwnProperty.call(ScheduledDowntimeKind, key)) {
            if (ScheduledDowntimeKind[key as keyof typeof ScheduledDowntimeKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ScheduledDowntimeKindFromJSON(json: any): ScheduledDowntimeKind {
    return ScheduledDowntimeKindFromJSONTyped(json, false);
}

export function ScheduledDowntimeKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduledDowntimeKind {
    return json as ScheduledDowntimeKind;
}

export function ScheduledDowntimeKindToJSON(value?: ScheduledDowntimeKind | null): any {
    return value as any;
}

